
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': '대시보드 작성',
	'dashboard': '대시보드',
	'dashboardTemplate': '대시보드 템플리트',
	'createAV': '작성',
	'createAvEditNameLabel': '1. 보기 이름 지정',
	'createAvSelectTemplateLabel': '2. 템플리트 선택',
	'tabLayoutLabel': '탭으로 구분된 템플리트',
	'infographicsLayoutLabel': '인포그래픽 템플리트',
	'singlePageLayoutLabel': '단일 페이지 템플리트',
	'customLayoutLabel': '사용자 정의 템플리트',
	'freeformTemplate': '자유 양식',
	'freeformTemplateDesc': '자유 양식 레이아웃의 시각화는 화면 크기에 관계없이 사용자가 크기를 지정하고 보기에 배치하는 대로 정확하게 표시됩니다. 기타 레이아웃에서는 시각화의 크기 및 위치가 화면에 맞게 조정됩니다.',
	'NoTemplate': '자유 양식',
	'Template1': '공백',
	'Template2': '제목 1x2',
	'Template3': '2/1',
	'Template4': '4/1',
	'Template5': '바닥글 1x2',
	'Template6': '3+1/1',
	'Template7': '4+3/1',
	'Template8': '2/3x2',
	'Template9': '2x2',
	'Template10': '1x2+2x2/1',
	'Template11': '3x1/1x2',
	'Template12': '2/1+1x2',
	'Template13': '1+1x2+1x4',
	'Template22': '1/2x2',
	'Template14': '1+1',
	'Template15': '1/1+1',
	'Template16': '1+1/1',
	'Template17': '1/1+1/1',
	'Template18': '1/1+1',
	'Template19': '1+2/1',
	'Template20': '1/2x1',
	'Template21': '1/1/2x1',
	'Template23': '끌어놓기 영역에서 공백',
	'Infographics1': '공백',
	'Infographics2': '4행',
	'Infographics3': '4행(머리글 포함)',
	'Infographics4': '2x4',
	'Infographics5': '대형 상단 디스플레이(2x2 포함)',
	'Infographics6': '2x4(세로 간격 포함)',
	'Infographics7': '2x4 지그재그형',
	'Infographics8': '테니스 경기장',
	'Infographics9': '3x4',
	'Infographics10': '4x8',
	'createAvDashboardLabel': '레이아웃',
	'dashboard_template_save_success': '대시보드 템플리트가 저장되었습니다.',
	'dashboard_template_prefix': '템플리트: "%{name}"',
	'dashboard_template_filters_removed': '캔버스에서 필터가 제거됩니다.',
	'createAvTabLabel': '탭',
	'createAvInfographicsLabel': '인포그래픽',
	'createAvSinglepageLabel': '단일 하나의',
	'createAvCustomLabel': '사용자 정의',
	'loadMoreLabel': '더 로드...',
	'backLabel': '되돌아가기',
	'addSourceLabel': '소스 추가',
	'pinLabel': '고정',
	'errorLoadingDataSetMetaData': '메타데이터를 읽는 중에 오류 발생',
	'errorLoadingDataSets': '데이터 세트 목록을 로드하는 중에 오류가 발생했습니다.',
	'errorLoadingDataSet': '데이터 세트 "%{datasetName}"에 대한 메타데이터가 로드되지 않았습니다. 세부사항은 관리자에게 문의하십시오.',
	'okButton': '확인',
	'createButton': '작성',
	'cancelButton': '취소',
	'copyButton': '복사',
	'selectTemplateLabel': '템플리트 선택',
	'createBoardTitle': '대시보드 작성',
	'createBoardSubtitle': '대시보드에 대한 템플리트 선택',
	'noSourcesSelectedLabel': '선택된 소스 없음',
	'find_label': '찾기',
	'noDashboardFound': '대시보드를 검색할 수 없습니다. 더 이상 존재하지 않거나 볼 수 있는 충분한 권한이 없습니다.',
	'errorLabel': '오류',
	'defaultName': '새 대시보드',
	'noDashboardCapability': '대시보드 애플리케이션을 실행할 기능이 없습니다.',
	'noCapabilityForCreateDashboard': '선택한 자산에 대해 대시보드를 작성하는 데 필요한 기능이 없습니다.',
	'noCapabilityForEdit': '이 대시보드를 편집할 수 있는 기능이 없습니다.',
	'noCapabilityForSave': '이 대시보드를 저장할 수 있는 기능이 없습니다.',
	'noCapabilityForPaste': '이 보기에서 복사된 위젯을 붙여넣을 수 있는 기능이 없음',
	'noCapabilityForPin': '이 핀을 추가할 수 있는 기능이 없습니다.',
	'noCapabilityForLaunchInExplore': '탐색에서 복사된 위젯을 실행할 수 있는 기능이 없음',
	'noDashboardPermission': '이 대시보드를 볼 수 있는 충분한 권한이 없습니다.',
	'sourceNotFound': '연관 소스 "%{sourceName}"을(를) 사용할 수 없으므로 시각화를 로드할 수 없음',
	'cmDuplicateName': '이 이름을 사용하는 항목이 이미 있습니다. 다른 이름을 시도하십시오.',
	'cmEmptySelection': '대시보드가 삭제되었습니다. 새 대시보드로 저장하십시오.',
	'propTheme_v1': '시각적 테마',
	'propTheme': '테마',
	'legacyThemeLabel': '레거시',
	'carbonGrey10Label': 'Carbon X 밝음',
	'carbonGrey100Label': 'Carbon X 어두움',
	'titleTextLabel': '제목',
	'titleSmallTextLabel': '작은 제목',
	'subtitleTextLabel': '부제목',
	'bodyTextLabel': '본문',
	'bodySmallTextLabel': '작은 본문',
	'captionTextLabel': '캡션',
	'quoteTextLabel': '인용',
	'quoteSmallTextLabel': '작은 인용',
	'responsiveTextLabel': '자동 크기',
	'mediaWidgetLabel': '매체',
	'webpageWidgetLabel': '웹 페이지',
	'imageWidgetLabel': '이미지',
	'textWidgetLabel': '텍스트',
	'notebookWidgetLabel': '노트북',
	'multipurposeWidgetLabel': '다목적',
	'textPlaceHolder': '클릭하여 텍스트 편집',
	'titlePlaceHolder': '클릭하여 제목 편집',
	'toggleEditModeLabel': '편집으로 전환',
	'togglePreviewModeLabel': '미리보기로 전환',
	'editDashboardCoachMarkTitle': '대시보드 편집',
	'editDashboardCoachMarkContents': '이 대시보드를 편집하려면 연필 아이콘을 클릭하십시오.',
	'addDataCoachMarkTitle': '데이터 추가',
	'addDataDashboardCoachMarkContents': '데이터 패널의 데이터를 끌어서 대시보드에 놓으십시오.',
	'pageSelectWarning': '탭을 선택하십시오.',
	'screenshot_label': '대시보드 %{title}',
	'screenshot_label_tab': '대시보드 %{title}의 탭 %{tabName}',
	'dataAssetPropertiesLabel': '시각화 특성',
	'modelFilter': '필터',
	'invertSelectionToolTip': '필터 반전 선택사항',
	'clearFilterValueToolTip': '필터 값 선택 취소',
	'invertFilterSelection': '반전',
	'clearTextFilterValue': '지우기',
	'filterConditionLabel': '필터 조건',
	'applyFilter': '필터 적용',
	'itemCountText': '%{itemCount}개 항목이 선택됨',
	'itemExcludeCountText': '%{itemCount}개 항목이 제외됨',
	'moreMembers': '계속 표시...',
	'searchHierarchyMembers': '구성원을 찾기 위해 검색 사용...',
	'propHideEmpty': '빈 항목 숨기기',
	'propColorOrder': '색상 순서',
	'propElementColor': '시각화 요소 색상',
	'propLineColor': '선 색상',
	'propLineAndSymbolColor': '선 및 기호 색상',
	'propColumnColor': '열 색상',
	'propBarColor': '막대 색상',
	'propWordColor': '단어 색상',
	'propAreaColor': '영역 색상',
	'propRadialbarColor': '방사형 막대 색상',
	'propColorPalettes': '색상표',
	'propDashboardColorPalette': '현재 대시보드 색상표',
	'propNewDashboardPaletteLabel': '사용자 정의 대시보드 색상표 작성',
	'propDashboardChangePaletteLink': '대시보드 색상표 변경',
	'propHideLeafNode': '리프 레이블 숨기기',
	'propOpacity_v1': '위젯 불투명도',
	'propOpacity': '위젯 불투명도(%)',
	'propOpacityDescription': '오브젝트의 불투명도를 높이거나 낮추십시오. 0 - 100 사이의 값으로 입력하십시오.',
	'addATab': '새 탭 추가',
	'propFredIsRed': '색상 일관성',
	'areaChartCaption': '영역형',
	'areaChartDataSlot_categoriesLabel': '축 레이블',
	'areaChartDataSlot_valuesLabel': '값',
	'areaChartProp_colorPaletteLabel': '색상표',
	'areaChartProp_lineColorLabel': '영역 색상',
	'areaChartProp_interpolationLabel': '곡선형',
	'areaChartProp_interpolationDescription': '데이터 점을 연결하는 선이 곡선입니다.',
	'areaChartProp_hideGridLinesLabel': '눈금선 숨기기',
	'areaChartProp_hideGridLinesDescription': '눈금선 숨기기',
	'areaChartProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'areaChartProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'areaChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'areaChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'areaChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'areaChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'barChartCaption': '막대형',
	'barChartDataSlot_categoriesLabel': '축 레이블',
	'barChartDataSlot_valuesLabel': '값',
	'barChartProp_colorPaletteLabel': '색상표',
	'barChartProp_elementColorLabel': '막대 색상',
	'barChartProp_hideGridLinesLabel': '눈금선 숨기기',
	'barChartProp_hideGridLinesDescription': '눈금선 숨기기',
	'barChartProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'barChartProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'barChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'barChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'barChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'barChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'columnChartCaption': '열',
	'columnChartDataSlot_categoriesLabel': '축 레이블',
	'columnChartDataSlot_valuesLabel': '값',
	'columnChartProp_colorPaletteLabel': '색상표',
	'columnChartProp_elementColorLabel': '열 색상',
	'columnChartProp_hideGridLinesLabel': '눈금선 숨기기',
	'columnChartProp_hideGridLinesDescription': '눈금선 숨기기',
	'columnChartProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'columnChartProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'columnChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'columnChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'columnChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'columnChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'bubbleChartCaption': '거품형',
	'bubbleChartDataSlot_xAxisLabel': '가로 축',
	'bubbleChartDataSlot_yAxisLabel': '세로 축',
	'bubbleChartDataSlot_sizeLabel': '크기 기준',
	'bubbleChartDataSlot_colorLabel': '색상 기준',
	'bubbleChartProp_colorPaletteLabel': '색상표',
	'bubbleChartProp_hideGridLinesLabel': '눈금선 숨기기',
	'bubbleChartProp_hideGridLinesDescription': '눈금선 숨기기',
	'bubbleChartProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'bubbleChartProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'bubbleChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'bubbleChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'bubbleChartProp_hideLegendLabel': '범례 숨기기',
	'bubbleChartProp_hideLegendDescription': '범례를 숨깁니다.',
	'bubbleChartProp_legendPositionLabel': '범례 위치',
	'lineChartCaption': '꺾은선형',
	'lineChartDataSlot_categoriesLabel': '축 레이블',
	'lineChartDataSlot_valuesLabel': '값',
	'lineChartProp_colorPaletteLabel': '색상표',
	'lineChartProp_lineColorLabel': '선 및 기호 색상',
	'lineChartProp_symbolShapeLabel': '기호 모양',
	'lineChartProp_hideSymbolsLabel': '기호 숨기기',
	'lineChartProp_hideSymbolsDescription': '기호 숨기기',
	'lineChartProp_hideDataLinesLabel': '선 숨기기',
	'lineChartProp_hideDataLinesDescription': '선 숨기기',
	'lineChartProp_interpolationLabel': '곡선형',
	'lineChartProp_interpolationDescription': '데이터 점을 연결하는 선이 곡선입니다.',
	'lineChartProp_hideGridLinesLabel': '눈금선 숨기기',
	'lineChartProp_hideGridLinesDescription': '눈금선 숨기기',
	'lineChartProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'lineChartProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'lineChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'lineChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'lineChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'lineChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'packedBubbleChart1CatCaption': '압축 거품',
	'packedBubbleChart1CatDataSlot_categoriesLabel': '카테고리',
	'packedBubbleChart1CatDataSlot_sizeLabel': '크기 기준',
	'packedBubbleChart1CatProp_colorPaletteLabel': '색상표',
	'packedBubbleChart1CatProp_elementColorLabel': '거품 색상',
	'packedBubbleChart1CatProp_hideLabelLabel': '레이블 숨기기',
	'packedBubbleChart1CatProp_hideValueLabel': '값 숨기기',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': '축 눈금 유지',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'packedBubbleChart1CatProp_suppressZerosLabel': '빈 항목 숨기기',
	'packedBubbleChart1CatProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'heatChartCaption': '히트',
	'heatChartDataSlot_valuesLabel': '히트 기준',
	'heatChartDataSlot_xAxisLabel': '가로 축',
	'heatChartDataSlot_yAxisLabel': '세로 축',
	'heatChartProp_colorPaletteLabel': '색상표',
	'heatChartProp_heatScalePaletteLabel': '색상 순서',
	'heatChartProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'heatChartProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'heatChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'heatChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'heatChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'heatChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'heatChartProp_hideLegendLabel': '범례 숨기기',
	'heatChartProp_hideLegendDescription': '범례를 숨깁니다.',
	'heatChartProp_legendPositionLabel': '범례 위치',
	'pieChartCaption': '원형',
	'pieChartDataSlot_categoriesLabel': '카테고리',
	'pieChartDataSlot_valuesLabel': '값',
	'pieChartProp_colorPaletteLabel': '색상표',
	'pieChartProp_hideRadialValueLabel': '값 숨기기',
	'pieChartProp_pieAsDonutLabel': '도넛형 차트로 표시',
	'pieChartProp_pieAsDonutDescription': '도넛형 차트로 표시',
	'pieChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'pieChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'pieChartProp_hideLegendLabel': '범례 숨기기',
	'pieChartProp_hideLegendDescription': '범례를 숨깁니다.',
	'pieChartProp_legendPositionLabel': '범례 위치',
	'map1measureCaption': '맵',
	'map1measureDataSlot_categoriesLabel': '영역',
	'map1measureDataSlot_valuesLabel': '영역 히트',
	'map1measureProp_colorPaletteLabel': '색상표',
	'map1measureProp_heatScalePaletteLabel': '색상 순서',
	'map1measureProp_maintainAxisScalesLabel': '축 눈금 유지',
	'map1measureProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'map1measureProp_suppressZerosLabel': '빈 항목 숨기기',
	'map1measureProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'map1measureProp_hideLegendLabel': '범례 숨기기',
	'map1measureProp_hideLegendDescription': '범례를 숨깁니다.',
	'map1measureProp_legendPositionLabel': '범례 위치',
	'radialChartCaption': '방사형',
	'radialChartDataSlot_categoriesLabel': '카테고리',
	'radialChartDataSlot_valuesLabel': '값',
	'radialChartProp_colorPaletteLabel': '색상표',
	'radialChartProp_elementColorLabel': '방사형 막대 색상',
	'radialChartProp_hideRadialTitleLabel': '제목 숨기기',
	'radialChartProp_hideRadialValueLabel': '값 숨기기',
	'radialChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'radialChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'radialChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'radialChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'pointChart1catCaption': '포인트형',
	'pointChart1catDataSlot_valuesLabel': '값',
	'pointChart1catDataSlot_categoriesLabel': '축 레이블',
	'pointChart1catProp_colorPaletteLabel': '색상표',
	'pointChart1catProp_elementColorLabel': '모양 색상',
	'pointChart1catProp_symbolShapeLabel': '기호 모양',
	'pointChart1catProp_symbolFillLabel': '모양 채우기',
	'pointChart1catProp_symbolFillDescription': '기호의 채우기 색상을 표시합니다.',
	'pointChart1catProp_hideGridLinesLabel': '눈금선 숨기기',
	'pointChart1catProp_hideGridLinesDescription': '눈금선 숨기기',
	'pointChart1catProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'pointChart1catProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'pointChart1catProp_maintainAxisScalesLabel': '축 눈금 유지',
	'pointChart1catProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'pointChart1catProp_suppressZerosLabel': '빈 항목 숨기기',
	'pointChart1catProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'scatterPlotChartNoCatCaption': '분산형 플롯',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': '가로 축',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': '세로 축',
	'scatterPlotChartNoCatProp_colorPaletteLabel': '색상표',
	'scatterPlotChartNoCatProp_elementColorLabel': '요소 색상',
	'scatterPlotChartNoCatProp_symbolShapeLabel': '기호 모양',
	'scatterPlotChartNoCatProp_symbolFillLabel': '모양 채우기',
	'scatterPlotChartNoCatProp_symbolFillDescription': '기호의 채우기 색상을 표시합니다.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': '눈금선 숨기기',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': '눈금선 숨기기',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'radialBarChartCaption': '방사형 막대',
	'radialBarChartDataSlot_categoriesLabel': '카테고리',
	'radialBarChartDataSlot_valuesLabel': '값',
	'radialBarChartProp_colorPaletteLabel': '색상표',
	'radialBarChartProp_elementColorLabel': '방사형 막대 색상',
	'radialBarChartProp_hideRadialTitleLabel': '제목 숨기기',
	'radialBarChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'radialBarChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'radialBarChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'radialBarChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'lineColumnComboChartCaption': '선 및 열',
	'lineColumnComboChartDataSlot_categoryLabel': '축 레이블',
	'lineColumnComboChartDataSlot_lineValueLabel': '선 값',
	'lineColumnComboChartDataSlot_columnValueLabel': '열 값',
	'lineColumnComboChartProp_colorPaletteLabel': '색상표',
	'lineColumnComboChartProp_elementColorLabel': '열 색상',
	'lineColumnComboChartProp_lineColorLabel': '선 및 기호 색상',
	'lineColumnComboChartProp_symbolShapeLabel': '기호 모양',
	'lineColumnComboChartProp_hideSymbolsLabel': '기호 숨기기',
	'lineColumnComboChartProp_hideSymbolsDescription': '기호 숨기기',
	'lineColumnComboChartProp_hideDataLinesLabel': '선 숨기기',
	'lineColumnComboChartProp_hideDataLinesDescription': '선 숨기기',
	'lineColumnComboChartProp_interpolationLabel': '곡선형',
	'lineColumnComboChartProp_interpolationDescription': '데이터 점을 연결하는 선이 곡선입니다.',
	'lineColumnComboChartProp_hideGridLinesLabel': '눈금선 숨기기',
	'lineColumnComboChartProp_hideGridLinesDescription': '눈금선 숨기기',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': '축 제목 레이블 숨기기',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': '축 제목을 숨깁니다.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'lineColumnComboChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'lineColumnComboChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'lineColumnComboChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'lineColumnComboChartProp_hideLegendLabel': '범례 숨기기',
	'lineColumnComboChartProp_hideLegendDescription': '범례를 숨깁니다.',
	'lineColumnComboChartProp_legendPositionLabel': '범례 위치',
	'summaryCaption': '요약',
	'areaName': '영역형',
	'areaDescription': '영역형',
	'areaDataSlot_colorLabel': '색상 기준',
	'areaDataSlot_valuesLabel': '값',
	'areaDataSlot_categoriesLabel': '축 레이블',
	'bubbleName': '거품형',
	'bubbleDescription': '거품형',
	'bubbleDataSlot_yAxisLabel': '세로 축',
	'bubbleDataSlot_xAxisLabel': '가로 축',
	'bubbleDataSlot_sizeLabel': '크기 기준',
	'bubbleDataSlot_colorLabel': '색상 기준',
	'clusterBarName': '막대형',
	'clusterBarDescription': '막대형',
	'clusterBarDataSlot_colorLabel': '색상 기준',
	'clusterBarDataSlot_valuesLabel': '값',
	'clusterBarDataSlot_categoriesLabel': '축 레이블',
	'clusterBarDataSlot_valuesRepeatingLabel': '값',
	'clusterColumnName': '열',
	'clusterColumnDescription': '열',
	'clusterColumnDataSlot_colorLabel': '색상 기준',
	'clusterColumnDataSlot_valuesLabel': '값',
	'clusterColumnDataSlot_categoriesLabel': '축 레이블',
	'clusterColumnDataSlot_valuesRepeatingLabel': '값',
	'clusterLineName': '꺾은선형',
	'clusterLineDescription': '꺾은선형',
	'clusterLineDataSlot_colorLabel': '색상 기준',
	'clusterLineDataSlot_valuesLabel': '세로 축',
	'clusterLineDataSlot_categoriesLabel': '가로 축',
	'clusterLineDataSlot_valuesRepeatingLabel': '값',
	'gridName': '눈금',
	'gridDescription': '눈금',
	'gridDataSlot_grid_colsLabel': '열',
	'heatName': '히트',
	'heatDescription': '히트',
	'heatDataSlot_yAxisLabel': '세로 축',
	'heatDataSlot_xAxisLabel': '가로 축',
	'heatDataSlot_valuesLabel': '히트 기준',
	'lineColumnComboName': '선 및 열',
	'lineColumnComboDescription': '선 및 열',
	'lineColumnComboDataSlot_lineValueLabel': '선 값',
	'lineColumnComboDataSlot_categoryLabel': '축 레이블',
	'lineColumnComboDataSlot_columnValueLabel': '열 값',
	'mapName': '레거시 맵',
	'mapDescription': '레거시 맵',
	'mapDataSlot_sizeLabel': '점 크기',
	'mapDataSlot_valuesLabel': '영역 히트',
	'mapDataSlot_sizeHeatLabel': '점 히트',
	'mapDataSlot_categoriesLabel': '영역',
	'packedBubbleName': '압축 거품',
	'packedBubbleDescription': '압축 거품',
	'packedBubbleDataSlot_sizeLabel': '크기 기준',
	'packedBubbleDataSlot_colorLabel': '색상 기준',
	'packedBubbleDataSlot_categoriesLabel': '카테고리',
	'pieName': '원형',
	'pieDescription': '원형',
	'pieDataSlot_valuesLabel': '값',
	'pieDataSlot_categoriesLabel': '카테고리',
	'playerName': '데이터 재생기',
	'playerDescription': '데이터 재생기',
	'playerDataSlot_categoriesLabel': '축 레이블',
	'pointName': '포인트형',
	'pointDescription': '포인트형',
	'pointDataSlot_colorLabel': '색상 기준',
	'pointDataSlot_valuesLabel': '값',
	'pointDataSlot_categoriesLabel': '축 레이블',
	'radialName': '방사형',
	'radialDescription': '방사형',
	'radialDataSlot_valuesLabel': '값',
	'radialDataSlot_maxSizeLabel': '최대값',
	'radialDataSlot_categoriesLabel': '카테고리',
	'radialBarName': '방사형 막대',
	'radialBarDescription': '방사형 막대',
	'radialBarDataSlot_valuesLabel': '값',
	'radialBarDataSlot_categoriesLabel': '카테고리',
	'scatterPlotName': '분산형 플롯',
	'scatterPlotDescription': '분산형 플롯',
	'scatterPlotDataSlot_yAxisLabel': '세로 축',
	'scatterPlotDataSlot_xAxisLabel': '가로 축',
	'scatterPlotDataSlot_colorLabel': '색상 기준',
	'scatterPlotDataSlot_categoriesLabel': '점',
	'stackedBarName': '누적 막대',
	'stackedBarDescription': '누적 막대',
	'stackedBarDataSlot_colorLabel': '색상 기준',
	'stackedBarDataSlot_valuesLabel': '값',
	'stackedBarDataSlot_categoriesLabel': '축 레이블',
	'stackedBarDataSlot_valuesRepeatingLabel': '값',
	'stackedColumnName': '누적 열',
	'stackedColumnDescription': '누적 열',
	'stackedColumnDataSlot_colorLabel': '색상 기준',
	'stackedColumnDataSlot_valuesLabel': '값',
	'stackedColumnDataSlot_categoriesLabel': '축 레이블',
	'stackedColumnDataSlot_valuesRepeatingLabel': '값',
	'summaryChartName': '요약',
	'summaryChartDescription': '요약',
	'summaryChartDataSlot_valuesLabel': '값',
	'treeMapName': '트리맵',
	'treeMapDescription': '트리맵',
	'treeMapDataSlot_colorLabel': '히트 기준',
	'treeMapDataSlot_valuesLabel': '크기 기준',
	'treeMapDataSlot_categoriesLabel': '1레벨',
	'treeMapDataSlot_level3Label': '3레벨',
	'treeMapDataSlot_level2Label': '2레벨',
	'wordCloudName': '단어 클라우드',
	'wordCloudDescription': '단어 클라우드',
	'wordCloudDataSlot_colorLabel': '색상 기준',
	'wordCloudDataSlot_scaleLabel': '크기 기준',
	'wordCloudDataSlot_wordLabel': '단어',
	'treeMap1Cat1MeasureChartCaption': '트리맵',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': '1레벨',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': '크기 기준',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': '색상표',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': '색상표',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': '색상표',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': '색상표',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': '색상표',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': '색상표',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': '축 눈금 유지',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': '빈 항목 숨기기',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': '범례 숨기기',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': '범례를 숨깁니다.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': '범례 위치',
	'wordChart1Cat1MeasureCaption': '단어 클라우드',
	'wordChart1Cat1MeasureDataSlot_wordLabel': '단어',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': '크기 기준',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': '색상표',
	'wordChart1Cat1MeasureProp_elementColorLabel': '단어 색상',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': '축 눈금 유지',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': '축의 최소값 및 최대값을 항상 표시합니다.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': '빈 항목 숨기기',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': '연관된 값이 없는 카테고리를 숨깁니다.',
	'missingDataSetData': '이 데이터 세트의 데이터를 사용할 수 없습니다. 데이터 세트를 새로 고치거나 소스 액세스에 대해 관리자에게 문의하십시오.',
	'hideShowSummaries': '요약 표시 숨기기',
	'crosstabName': '교차 분석',
	'value_is_not_available': '해당사항 없음',
	'swapRowsAndColumns': '행과 열 바꾸기',
	'NoPinsCollected': '고정된 시각화 없음',
	'pinSearchOld': '내 핀 검색',
	'pinDeletedToast': '핀이 제거됨',
	'pinAddedToast': '핀이 내 핀에 추가됨',
	'pinRetrieveError': '하나 이상의 핀을 검색할 수 없습니다. 나중에 다시 시도하십시오.',
	'pinErrorTitle': '고정 오류',
	'renamePinTooltip': '이름 입력...',
	'renamePinInvalidText': '이 필드는 필수입니다.',
	'pinRemove': '제거',
	'deletePin': '핀 삭제',
	'renamePin': '이름 바꾸기',
	'cancelRenamePin': '취소',
	'confirmRenamePin': '완료',
	'dataset_time': '시간',
	'dataset_date': '날짜',
	'dataset_location': '위치',
	'dataset_number': '숫자',
	'dataset_text': '텍스트',
	'widgetConditionalFormatLabel': '조건부 형식 제어 토글',
	'deletePinConfirmationMessage': '이 핀을 삭제하시겠습니까? 실행을 취소할 수 없습니다.',
	'deletePinConfirm': '삭제 확인',
	'pinDeleteError': '하나 이상의 핀을 삭제할 수 없습니다. 나중에 다시 시도하십시오.',
	'metadataPickerTitle': '데이터 세트 작성',
	'moreTitle': '자세히',
	'remove_slider_handle': '핸들 제거',
	'missingFiltering': '열 누락:',
	'unSupportedPromptType': '프롬프트 시나리오는 현재 지원되지 않습니다.',
	'preAggregateLabel': '데이터 소스에서 프롬프트 값 적용',
	'postAggregateLabel': '보고서에서 프롬프트 값 적용',
	'preAggregateText': '이 범위에서는 대시보드에 표시된 값이 아닌 데이터 소스의 값을 사용합니다.',
	'tabName_general': '일반', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': '세부사항',
	'tabName_textDetails': '텍스트 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': '매체 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': '웹 페이지 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': '이미지 세부사항', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': '시각화',
	'sectionName_canvas': '캔버스',
	'sectionName_colorsAndThemes_v1': '색상 및 테마',
	'sectionName_colorsAndThemes': '테마 및 배경',
	'colorsAndThemes_legacyWarning': '현재 대시보드에서 이전 릴리스의 테마를 사용하고 있습니다. 테마를 변경하고 대시보드를 저장하면 이전 테마 색상표에 대한 액세스가 영구 제거됩니다. ',
	'sectionName_details': '세부사항',
	'sectionName_positionAndStyle': '위치 및 스타일',
	'sectionName_appearance': '모양', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': '고급',
	'sectionName_layout': '레이아웃', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': '탭 레이블',
	'sectionName_tabTitle': '레이블',
	'sectionName_tabBackground': '배경',
	'addDataSourceDialogTitle': '데이터 소스 추가',
	'addDataSourceDialogButtonLabel': '추가',
	'shapesDoubleChevron': '이중 V형 무늬',
	'widgetsPanelTitle': '위젯',
	'widgetsPanelBasicsTab': '기본',
	'widgetsPanelImageLibraryTab': '이미지',
	'widgetsPanelSectionStandard': '표준',
	'widgetsPanelSectionAdvanced': '고급',
	'widgetsPanelSectionShapes': '도형',
	'customWidgetsTitle': '사용자 정의 위젯',
	'filterItemCanvasMove': '캔버스에 추가',
	'filterOverflowMenu_Global': '모든 탭 오버플로우 메뉴',
	'filterOverflowMenu_Tab': '이 탭 오버플로우 메뉴',
	'filterOverflowMenu_Item': '필터 오버플로우 메뉴',
	'filterOverflowMenu_Single': '오버플로우 메뉴',
	'filterItemEdit': '필터 값 편집',
	'filterDeleteAllItems': '필터 모두 삭제',
	'filterClearAllItems': '필터 모두 지우기',
	'filterClearSelection': '필터 지우기',
	'filterPlayerMode': '재생기 표시',
	'filterStaticMode': '목록 표시',
	'filterInvertSelection': '필터 전환',
	'filterIconLabel_Global': '모든 탭',
	'filterIconLabel_Single': '필터',
	'filterIconLabel_Tab': '이 탭',
	'filterIconTooltip_Global': '모든 탭',
	'filterIconTooltip_Tab': '이 탭',
	'filterIconTooltip_Single': '필터',
	'filterItemDelete': '필터 삭제',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': '다음을 제외한 모두: %{from}-%{to}',
	'filterExcept': '%{values} 제외',
	'filterAll': '모두',
	'filterBlank': '(공백)',
	'filterDisableRangeInvert': '이 열이 "모든 탭" 필터에 있을 때는 사용 불가능합니다.',
	'filterDisableHierarchyInvert': '이 열이 계층 구조 필터에 있을 때는 사용 불가능합니다.',
	'filterSelectedOfTotal': '%{selected}/%{totalMembers}',
	'filter_date_before': '%{to} 이전',
	'filter_date_before_except': '%{to} 이전 제외',
	'filter_date_after': '%{from} 이후',
	'filter_date_after_except': '%{from} 이후 제외',
	'filter_date_between': '%{from}-%{to} 범위',
	'filter_date_between_except': '%{from}-%{to} 범위 제외',
	'filter_drag_and_drop_all_tabs': '모든 탭을 필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'filter_drag_and_drop_current_tab': '이 탭을 필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'filter_drag_and_drop_single_dock': '필터링하려면 데이터를 여기에 끌어서 놓으십시오.',
	'errMsgFilterItemGenericTitle': '필터 값을 로드할 수 없음',
	'widgetChromeRotate': '회전',
	'toolbarRegionLabel': '도구 모음',
	'toolbarActionDelete': '삭제',
	'toolbarActionGroup': '그룹',
	'toolbarActionUngroup': '그룹화 해제',
	'toolbarActionOrderToFront': '앞으로 보내기',
	'toolbarActionOrderToBack': '뒤로 보내기',
	'toolbarActionEditTitle': '제목 편집',
	'toolbarActionWrapTitle': '제목 줄 바꾸기',
	'toolbarActionPin': '수집',
	'toolbarActionPinOld': '고정',
	'toolbarActionAlign': '맞추기',
	'alignWidgetLeft': '왼쪽',
	'alignWidgetCenter': '가운데',
	'alignWidgetRight': '오른쪽',
	'alignWidgetTop': '상위',
	'alignWidgetMiddle': '중간',
	'alignWidgetBottom': '하위',
	'distributeWidgetsVertical': '수직 분배',
	'distributeWidgetsHoriz': '수평으로 분배',
	'toolbarChangeVisualization': '시각화 변경',
	'multipurposeHeader': '위젯 유형 선택',
	'multipurposePlaceholderText': '시작하려면 위젯을 하나 선택하십시오. ',
	'live_label': '차트',
	'filter_label': '필터',
	'one_named_live': '%{name} 차트',
	'one_named_live_numbered': '%{name} 차트(%{number})',
	'one_unknown_live': '차트',
	'one_unknown_live_numbered': '차트(%{number})',
	'few_live': '%{count} 차트의 그룹',
	'many_live': '%{count} 차트의 그룹',
	'one_custom': '사용자 정의 위젯',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} 필터',
	'one_named_filter_numbered': '%{name} 필터(%{number})',
	'one_unknown_filter': '필터',
	'one_unknown_filter_numbered': '필터(%{number})',
	'few_filter': '%{count} 필터의 그룹',
	'many_filter': '%{count} 필터의 그룹',
	'LIVE_bar_has_mapping': '%{values} 막대형 차트',
	'LIVE_bar_has_mapping_numbered': '%{values} 막대형 차트(%{number})',
	'LIVE_bar_opt_mapping': '%{categories}, 기준: %{values} 막대형 차트',
	'LIVE_bar_opt_mapping_numbered': '%{categories}, 기준: %{values} 막대형 차트(%{number})',
	'LIVE_bar_no_mapping': '비어 있는 막대형 차트',
	'LIVE_bar_no_mapping_numbered': '빈 막대형 차트(%{number})',
	'LIVE_bar_named': '%{name} 막대형 차트',
	'LIVE_bar_named_numbered': '%{name} 막대형 차트(%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} 누적 막대형 차트',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} 누적 막대형 차트(%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{categories}, 기준: %{values} 누적막대형 차트',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories}, 기준: %{values} 누적 막대형 차트(%{number})',
	'LIVE_stacked_bar_no_mapping': '비어 있는 누적 막대형 차트',
	'LIVE_stacked_bar_no_mapping_numbered': '빈 누적 막대형 차트(%{number})',
	'LIVE_stacked_bar_named': '%{name} 누적 막대형 차트',
	'LIVE_stacked_bar_named_numbered': '%{name} 누적 막대형 차트(%{number})',
	'LIVE_bubble_has_mapping': '%{categories}, 기준: %{x} 및 %{y} 거품형 차트',
	'LIVE_bubble_has_mapping_numbered': '%{categories}, 기준: %{x} 및 %{y} 거품형 차트(%{number})',
	'LIVE_bubble_no_mapping': '비어 있는 거품형 차트',
	'LIVE_bubble_no_mapping_numbered': '빈 거품형 차트(%{number})',
	'LIVE_bubble_named': '%{name} 거품형 차트',
	'LIVE_bubble_named_numbered': '%{name} 거품형 차트(%{number})',
	'LIVE_composite_has_mapping': '%{categories}, 기준: %{columnValue} 및 %{lineValue} 복합형 차트',
	'LIVE_composite_has_mapping_numbered': '%{categories}, 기준: %{columnValue} 및 %{lineValue} 복합형 차트(%{number})',
	'LIVE_composite_no_mapping': '비어 있는 복합형 차트',
	'LIVE_composite_no_mapping_numbered': '빈 복합형 차트(%{number})',
	'LIVE_composite_named': '%{name} 복합형 차트',
	'LIVE_composite_named_numbered': '%{name} 복합형 차트(%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} 의사결정 트리',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} 의사결정 트리(%{number})',
	'LIVE_decision_tree_no_mapping': '비어 있는 의사결정 트리',
	'LIVE_decision_tree_no_mapping_numbered': '빈 의사결정 트리(%{number})',
	'LIVE_decision_tree_named': '%{name} 의사결정 트리',
	'LIVE_decision_tree_named_numbered': '%{name} 의사결정 트리(%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} 압축 거품형 차트',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} 압축 거품형 차트(%{number})',
	'LIVE_packed_bubble_no_mapping': '비어 있는 압축 거품형 차트',
	'LIVE_packed_bubble_no_mapping_numbered': '빈 압축 거품형 차트(%{number})',
	'LIVE_packed_bubble_named': '%{name} 압축 거품형 차트',
	'LIVE_packed_bubble_named_numbered': '%{name} 압축 거품형 차트(%{number})',
	'LIVE_pie_has_mapping': '%{categories}, 기준: %{values} 원형 차트',
	'LIVE_pie_has_mapping_numbered': '%{categories}, 기준: %{values} 원형 차트(%{number})',
	'LIVE_pie_no_mapping': '비어 있는 원형 차트',
	'LIVE_pie_no_mapping_numbered': '빈 원형 차트(%{number})',
	'LIVE_pie_named': '%{name} 원형 차트',
	'LIVE_pie_named_numbered': '%{name} 원형 차트(%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{categories}, 기준: %{values} 도넛형 차트',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories}, 기준: %{values} 도넛형 차트(%{number})',
	'LIVE_pie_as_donut_no_mapping': '비어 있는 도넛형 차트',
	'LIVE_pie_as_donut_no_mapping_numbered': '빈 도넛형 차트(%{number})',
	'LIVE_pie_as_donut_named': '%{name} 도넛형 차트',
	'LIVE_pie_as_donut_named_numbered': '%{name} 도넛형 차트(%{number})',
	'LIVE_line_has_mapping': '%{categories}, 기준: %{values} 선형 차트',
	'LIVE_line_has_mapping_numbered': '%{categories}, 기준: %{values} 선형 차트(%{number})',
	'LIVE_line_no_mapping': '비어 있는 꺽은선형 차트',
	'LIVE_line_no_mapping_numbered': '빈 선형 차트(%{number})',
	'LIVE_line_named': '%{name} 선형 차트',
	'LIVE_line_named_numbered': '%{name} 선형 차트(%{number})',
	'LIVE_area_has_mapping': '%{categories}, 기준: %{values} 영역 차트',
	'LIVE_area_has_mapping_numbered': '%{categories}, 기준: %{values} 영역 차트(%{number})',
	'LIVE_area_no_mapping': '비어 있는 영역 차트',
	'LIVE_area_no_mapping_numbered': '빈 영역 차트(%{number})',
	'LIVE_area_named': '%{name} 영역 차트',
	'LIVE_area_named_numbered': '%{name} 영역 차트(%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories}, 기준: %{values}누적 퍼센트 영역 차트',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories}, 기준: %{values} 누적 퍼센트 영역 차트(%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': '비어 있는 누적 퍼센트 영역 차트',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': '빈 누적 퍼센트 영역 차트(%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} 누적 퍼센트 영역 차트',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} 누적 퍼센트 영역 차트(%{number})',
	'LIVE_heatmap_has_mapping': '%{color} 히트맵',
	'LIVE_heatmap_has_mapping_numbered': '%{color} 히트맵(%{number})',
	'LIVE_heatmap_no_mapping': '비어 있는 히트맵',
	'LIVE_heatmap_no_mapping_numbered': '빈 히트맵(%{number})',
	'LIVE_heatmap_named': '%{name} 히트맵',
	'LIVE_heatmap_named_numbered': '%{name} 히트맵(%{number})',
	'LIVE_network_opt_mapping': '%{categories}, 기준: %{series} 및 %{values} 네트워크',
	'LIVE_network_opt_mapping_numbered': '%{categories}, 기준: %{series} 및 %{values} 네트워크(%{number})',
	'LIVE_network_has_mapping': '%{categories}, 기준: %{series} 네트워크',
	'LIVE_network_has_mapping_numbered': '%{categories}, 기준: %{series} 네트워크(%{number})',
	'LIVE_network_no_mapping': '비어 있는 네트워크',
	'LIVE_network_no_mapping_numbered': '빈 네트워크(%{number})',
	'LIVE_network_named': '%{name} 네트워크',
	'LIVE_network_named_numbered': '%{name} 네트워크(%{number})',
	'LIVE_radial_bar_opt_mapping': '%{categories}, 기준: %{values} 방사형 막대형 차트',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories}, 기준: %{values} 방사형 막대형 차트(%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} 방사형 막대형 차트',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} 방사형 막대형 차트(%{number})',
	'LIVE_radial_bar_no_mapping': '비어 있는 방사형 막대형 차트',
	'LIVE_radial_bar_no_mapping_numbered': '빈 방사형 막대형 차트(%{number})',
	'LIVE_radial_bar_named': '%{name} 방사형 막대형 차트',
	'LIVE_radial_bar_named_numbered': '%{name} 방사형 막대형 차트(%{number})',
	'LIVE_spiral_has_mapping': '%{values} 나선형 차트',
	'LIVE_spiral_has_mapping_numbered': '%{values} 나선형 차트(%{number})',
	'LIVE_spiral_no_mapping': '비어 있는 나선형 차트',
	'LIVE_spiral_no_mapping_numbered': '빈 나선형 차트(%{number})',
	'LIVE_spiral_named': '%{name} 나선형 차트',
	'LIVE_spiral_named_numbered': '%{name} 나선형 차트(%{number})',
	'LIVE_treemap_has_mapping': '%{categories}, 기준: %{size} 트리 맵',
	'LIVE_treemap_has_mapping_numbered': '%{categories}, 기준: %{size} 트리 맵(%{number})',
	'LIVE_treemap_no_mapping': '비어 있는 트리맵',
	'LIVE_treemap_no_mapping_numbered': '빈 트리 맵(%{number})',
	'LIVE_treemap_named': '%{name} 트리 맵',
	'LIVE_treemap_named_numbered': '%{name} 트리 (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} 단어 클라우드',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} 단어 클라우드(%{number})',
	'LIVE_wordcloud_no_mapping': '비어 있는 단어 클라우드',
	'LIVE_wordcloud_no_mapping_numbered': '빈 단어 클라우드(%{number})',
	'LIVE_wordcloud_named': '%{name} 단어 클라우드',
	'LIVE_wordcloud_named_numbered': '%{name} 단어 클라우드(%{number})',
	'LIVE_data_player_has_mapping': '%{category} 데이터 재생기',
	'LIVE_data_player_has_mapping_numbered': '%{category} 데이터 재생기(%{number})',
	'LIVE_data_player_no_mapping': '비어 있는 데이터 재생기',
	'LIVE_data_player_no_mapping_numbered': '빈 데이터 재생기(%{number})',
	'LIVE_data_player_named': '%{name} 데이터 재생기',
	'LIVE_data_player_named_numbered': '%{name} 데이터 재생기(%{number})',
	'LIVE_map_has_mapping': '%{locations} 맵',
	'LIVE_map_has_mapping_numbered': '%{locations} 맵(%{number})',
	'LIVE_map_no_mapping': '비어 있는 맵',
	'LIVE_map_no_mapping_numbered': '빈 맵(%{number})',
	'LIVE_map_named': '%{name} 맵',
	'LIVE_map_named_numbered': '%{name} 맵(%{number})',
	'LIVE_point_has_mapping': '%{categories}, 기준: %{values} 포인트형 차트',
	'LIVE_point_has_mapping_numbered': '%{categories}, 기준: %{values} 포인트형 차트(%{number})',
	'LIVE_point_no_mapping': '비어 있는 포인트형 차트',
	'LIVE_point_no_mapping_numbered': '빈 포인트형 차트(%{number})',
	'LIVE_point_named': '%{name} 포인트형 차트',
	'LIVE_point_named_numbered': '%{name} 포인트형 차트(%{number})',
	'LIVE_column_has_mapping': '%{values} 세로 막대형 차트',
	'LIVE_column_has_mapping_numbered': '%{values} 세로 막대형 차트(%{number})',
	'LIVE_column_opt_mapping': '%{categories}, 기준: %{values} 세로 막대형 차트',
	'LIVE_column_opt_mapping_numbered': '%{categories}, 기준: %{values} 세로 막대형 차트(%{number})',
	'LIVE_column_no_mapping': '비어 있는 세로 막대형 차트',
	'LIVE_column_no_mapping_numbered': '빈 세로 막대형 차트(%{number})',
	'LIVE_column_named': '%{name} 세로 막대형 차트',
	'LIVE_column_named_numbered': '%{name} 세로 막대형 차트(%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} 누적 세로 막대형 차트',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} 누적 세로 막대형 차트(%{number})',
	'LIVE_stacked_column_opt_mapping': '%{categories}, 기준: %{values} 누적 세로 막대형 차트',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories}, 기준: %{values}누적 세로 막대형 차트(%{number})',
	'LIVE_stacked_column_no_mapping': '비어 있는 누적 세로 막대형 차트',
	'LIVE_stacked_column_no_mapping_numbered': '빈 누적 세로 막대형 차트(%{number})',
	'LIVE_stacked_column_named': '%{name} 누적 세로 막대형 차트',
	'LIVE_stacked_column_named_numbered': '%{name} 누적 세로 막대형 차트(%{number})',
	'LIVE_scatter_opt_mapping': '%{categories}, 기준: %{x} 및 %{y} 산포도',
	'LIVE_scatter_opt_mapping_numbered': '%{categories}, 기준: %{x} 및 %{y} 산포도(%{number})',
	'LIVE_scatter_has_mapping': '%{x} 및 %{y} 산포도',
	'LIVE_scatter_has_mapping_numbered': '%{x} 및 %{y} 산포도(%{number})',
	'LIVE_scatter_no_mapping': '비어 있는 분산형 점',
	'LIVE_scatter_no_mapping_numbered': '빈 산포도(%{number})',
	'LIVE_scatter_named': '%{name} 산포도',
	'LIVE_scatter_named_numbered': '%{name} 산포도(%{number})',
	'LIVE_waterfall_has_mapping': '%{values} 워터폴 차트',
	'LIVE_waterfall_has_mapping_numbered': '%{values} 워터폴 차트(%{number})',
	'LIVE_waterfall_no_mapping': '빈 워터폴 차트',
	'LIVE_waterfall_no_mapping_numbered': '빈 워터폴 차트(%{number})',
	'LIVE_waterfall_named': '%{name} 워터폴 차트',
	'LIVE_waterfall_named_numbered': '%{name} 워터폴 차트(%{number})',
	'LIVE_empty_visualization_hint_title': '시각화 빌드',
	'LIVE_empty_visualization_hint_description': '여기 또는 왼쪽의 슬롯에 열을 끌어서 놓습니다.',
	'LIVE_slots_required_field_description': '%{asterisk} 필수 필드 표시',
	'LIVE_slots_drag_and_drop_description': '가상화를 빌드하고 필터링하려면 위의 슬롯에 데이터를 끌어서 놓습니다.',
	'requiredField': '필수 필드',
	'fullScreenEnter': '전체 화면 설정',
	'fullScreenClose': '전체 화면 종료',
	'noExtraText_multipurpose': '다목적 플레이스홀더',
	'noExtraText_multipurpose_numbered': '다용도 플레이스홀더(%{number})',
	'one_placeholder_vis': '시각화 플레이스홀더',
	'one_placeholder_vis_numbered': '시각화 플레이스홀더(%{number})',
	'one_placeholder_text': '텍스트 플레이스홀더',
	'one_placeholder_text_numbered': '텍스트 플레이스홀더(%{number})',
	'few_placeholder_text': '%{count}개 텍스트 플레이스홀더의 그룹',
	'many_placeholder_text': '%{count}개 텍스트 플레이스홀더의 그룹',
	'filter_includesAll': '모두 포함',
	'timeline_filter_moved_to': '타임라인 필터 %{id}이(가) %{time}(으)로 이동됨',
	'timelineSettingsButton': '재생 옵션',
	'autoPlay': '모든 장면 재생',
	'loop': '루프',
	'noSceneTransitionLabel': '없음',
	'sceneTransitionPropertyLabel': '장면 전환',
	'animatedPathSceneTransitionLabel': '애니메이션 경로',
	'sweepSceneTransitionLabel': '스윕',
	'propAniAnimation': '애니메이션',
	'propAniTypeEntrance': '시작 애니메이션',
	'propAniDirectionIn': '시작 방향',
	'propAniTypeExit': '종료 애니메이션',
	'propAniDirectionOut': '종료 방향',
	'propAniDirection': '방향',
	'timelineAnimationProperties': '애니메이션 특성 열기',
	'editStoryCoachMarkTitle': '스토리 편집',
	'editStoryCoachMarkContents': '이 스토리를 편집하려면 연필 아이콘을 클릭하십시오.',
	'addDataStoryCoachMarkContents': '데이터 패널의 데이터를 끌어서 스토리에 놓으십시오.',
	'expandSceneCoachmarkTitle': '타임라인 열기',
	'expandSceneCoachmarkContents': '시간 및 지속 기간을 기반으로 오브젝트 가시성을 적용하여 장면을 애니메이트하십시오.',
	'overviewCoachmarkTitle': '개요 장면',
	'overviewCoachmarkContents': '스토리의 시작 및 마지막에서 개요 장면을 사용하여 모든 장면의 큰 그림을 표시하십시오. 개요 장면에서 장면을 클릭하여 끌어와 다른 장면으로 교환하십시오. 스토리 특성에서 개요 장면을 표시하거나 숨길 수 있습니다.',
	'animatedPathCoachmarkTitle': '애니메이션 경로',
	'animatedPathCoachmarkContents': '오브젝트를 하나의 장면에서 다른 장면으로 애니메이션화하려면 오브젝트가 있는 장면을 복제하십시오. 그리고 새 장면에서 복제된 오브젝트를 이동, 크기 조정하거나 회전하십시오.',
	'tabName_animation': '애니메이션',
	'textWidgetIconPlaceholderText': '클릭하여 텍스트 추가',
	'buildVisHeader': '시각화 작성',
	'visIconPlaceholderText': '필드를 끌어서 놓는 방법으로 시각화 빌드',
	'launchNewExplore': '새 탐색',
	'addTo': '추가 위치',
	'addToExisting': '기존에 추가...',
	'exploreData': '탐색',
	'explore_remove_widget_styles': '색상 설정과 같은 사용자 정의 시각화 특성은 탐색에서 지속되지 않습니다.',
	'editNotebook': '위젯 편집',
	'thumbnails_error_fetching': '축소 그림 페치 오류',
	'copy': '%{count} 자산이 복사됨',
	'specConvertErr': '대시보드 사양을 붙여넣거나 변환하는 중에 오류 발생',
	'specCopyErr': '대시보드 사양 복사 오류',
	'pasteNotSupportedErr': '%{name}에서 붙여넣기는 지원되지 않습니다.',
	'reportParam': '보고서',
	'filterWidgetCopyWarn': '현재 필터가 지원되지 않으므로 필터 시각화가 복사되지 않았습니다.',
	'upgradingDashboard': '%{version}에 대한 "%{name}" 업그레이드 중...',
	'upgradeComplete': '업그레이드 완료',
	'individualTabProperties': '개별 탭 특성',
	'propMasterTabStylesLabel_v1': '글로벌 탭 스타일링',
	'propMasterTabStylesLabel': '모든 탭 스타일링',
	'propTabPosition': '탭 위치',
	'propTabTitle': '제목',
	'propTabBackgroundColor': '채우기 색상',
	'propTabTextColor': '제목 색상',
	'propTabSelectedBarColor': '선택한 막대 색상',
	'propTabRestoreDefaults': '기본값 복원',
	'propIndividualTabStylesLabel': '개별 탭 스타일링',
	'propIndividualTabStylesAriaLabel': '개별 탭 스타일링 특성 열기',
	'propTabIconPosition': '아이콘 위치',
	'propLeftTitle': '제목 왼쪽',
	'propRightTitle': '제목 오른쪽',
	'propTopTitle': '제목 위',
	'propBottomTitle': '제목 아래',
	'propTabIconLabel': '시각적',
	'propTabIcon': '아이콘',
	'propTabIconColor': '아이콘 색상',
	'no_icon': '비어 있음',
	'announcement': '공지사항',
	'api': 'API',
	'archive': '아카이브',
	'asset': '자산',
	'attachment': '첨부 파일',
	'audio': '오디오',
	'bee': '벌',
	'blog': '블로그',
	'bookmark': '책갈피',
	'calendar': '달력',
	'camera': '카메라',
	'capability': '기능',
	'catalog': '카탈로그',
	'chat_message': '대화 메시지',
	'checkout_cart': '카트 체크아웃',
	'client': '클라이언트',
	'clock': '시계',
	'cloud': '구름',
	'code': '코드',
	'data_quality': '데이터 품질',
	'folder': '폴더',
	'forum': '포럼',
	'glasses': '클래스',
	'group': '그룹',
	'hat': '모자',
	'headphone': '헤드폰',
	'hills': '언덕',
	'home': '홈',
	'idea': '아이디어',
	'image': '이미지',
	'inventory': '인벤토리',
	'like': '좋아요',
	'link': '링크',
	'location': '위치',
	'manage': '관리',
	'pen': '펜',
	'mobile_phone': '휴대폰',
	'music': '음악',
	'notifications': '알림',
	'paint': '페인트',
	'payment': '결제',
	'password_key': '비밀번호 키',
	'people': '사용자',
	'person': '개인',
	'phone': '전화',
	'pin': '고정',
	'print': '인쇄',
	'recording': '녹화',
	'repository': '리포지토리',
	'role': '역할',
	'search': '검색',
	'properties': '특성',
	'speaker': '스피커',
	'star': '별 모양',
	'tag': '태그',
	'thumbs_up': '엄지 위로',
	'thumbs_down': '엄지 아래로',
	'tools': '도구',
	'traffic': '트래픽',
	'trash': '휴지통',
	'twitter': 'Twitter',
	'unknown': '알 수 없음',
	'user': '사용자',
	'venn_diagram': '벤 다이어그램',
	'video': '비디오',
	'view': '보기',
	'warning': '경고',
	'watch': '감시',
	'watson': 'Watson',
	'wikis': 'Wikis',
	'workspace': '작업공간',
	'world': '세계',
	'eventGroupButtonLabel': '위젯 연결 보기',
	'dockToolbar': '도구 모음 고정',
	'undockToolbar': '도구 모음 고정 해제',
	'propShowTitle': '제목 표시',
	'textAutoFontSize': '자동',
	'zoomFitToWidth': '너비에 맞추기',
	'zoomWholePage': '페이지에 맞추기',
	'defaultZoomValue': '기본 확대/축소 값',
	'zoomCategoryLabel': '페이지 확대/축소(절대 레이아웃 전용)'
});
